// Image cache to prevent reloading images
const imageCache = new Map<string, HTMLImageElement>();

// Load an image with caching
export const loadImage = (url: string): Promise<HTMLImageElement> => {
  // Check if the image is already in the cache
  if (imageCache.has(url)) {
    return Promise.resolve(imageCache.get(url)!);
  }

  // Otherwise, load the image
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      imageCache.set(url, img);
      resolve(img);
    };

    img.onerror = () => {
      reject(new Error(`Failed to load image: ${url}`));
    };

    img.src = url;
  });
};
